import { attr, belongsTo } from '@ember-data/model';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
import NumericEnum from '@square/dashboard-utilities/utils/numeric-enum';
export const SubscriptionCadence = NumericEnum.create(['SUBSCRIPTION_CADENCE_DO_NOT_USE', 'DAILY', 'WEEKLY', 'EVERY_TWO_WEEKS', 'THIRTY_DAYS', 'SIXTY_DAYS', 'NINETY_DAYS', 'MONTHLY', 'EVERY_TWO_MONTHS', 'QUARTERLY', 'EVERY_FOUR_MONTHS', 'EVERY_SIX_MONTHS', 'ANNUAL', 'EVERY_TWO_YEARS']);
export default ItemsV3Base.extend({
  subscriptionCadence: attr('enum', {
    enumClass: SubscriptionCadence
  }),
  subscriptionPeriods: attr('number'),
  ordinal: attr('number'),
  subscriptionPlan: belongsTo('subscription-plan'),
  price: attr('legacy-money')
}).reopenClass({
  catalogType() {
    return 'SUBSCRIPTION_PHASE';
  }
});